"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sanitizeForJSON;

function sanitizeForJSON(str) {
  var WHITESPACE_CHAR_REGEX = /\t|\r|\n/g;
  var RIGHT_DOUBLE_QUOTE_ENTITY = "\u201D";

  if (typeof str !== 'string') {
    return JSON.stringify(str);
  }

  return str.trim().replace(WHITESPACE_CHAR_REGEX, ' ').replace(/"/g, RIGHT_DOUBLE_QUOTE_ENTITY);
}

//# sourceMappingURL=sanitizeForJson.js.map